<template>
    <div class="details-tab">
        <div class="md-layout md-alignment-space-between-left md-gutter">
            <h3 class="md-layout-item card-title media-body">{{title}}</h3>
<!--            <div class="md-layout-item md-layout md-gutter  md-alignment-right ">-->
<!--                <div class="md-layout-item dropdown">-->
<!--                    <a href="#" class="btn btn-sm " data-toggle="dropdown" aria-expanded="true">-->
<!--                        <i class="material-icons">more_vert</i>-->
<!--                    </a>-->
<!--                    <div class="dropdown-menu dropdown-menu-right"-->
<!--                         style="clip: rect(0px, 93.8594px, 0px, 93.8594px); transform: translate3d(-53.8594px, 0px, 0px);">-->
<!--                        <a class="dropdown-item d-flex flex-row" id="edit-employee-info" href="javascript:void(0);">-->
<!--                            <i class="material-icons md-dark pmd-icon-xs mr-3">edit</i><span-->
<!--                                class="media-body">Edit</span>-->
<!--                        </a>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <div class="md-layout">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ItemsView',
    props:{
        title:{
            type:String
        }
    }
};
</script>

<style scoped>
    .mb-0 {
        margin-bottom: 0;
    }

    .mt-0 {
        margin-top: 0;
    }
</style>
